import { getGtmClient } from './gtm'

// All metrics sent with this method need to be added to this list or they will be blocked:
// https://github.com/intercom/intercom/blob/420649d/app/controllers/api/visitor_analytics/metrics_controller.rb#L11
export async function incrementMetric(name: string, tags?: Record<string, string>): Promise<void> {
  const gtmClient = await getGtmClient()
  gtmClient.incrementMetric(name, tags)
}
